import type { ReactNode } from "react"
import { btnStyle, loaderStyle } from "./button.css"

type Props = {
  type: "submit" | "button" | "reset"
  children: ReactNode
  isSubmitting?: boolean
  disabled?: boolean
  className?: string
} & React.ButtonHTMLAttributes<HTMLButtonElement>

function Button({
  type,
  className,
  children,
  isSubmitting = false,
  disabled = false,
  ...props
}: Props) {
  return (
    <button
      className={`${btnStyle} ${className || ""}`}
      type={type}
      disabled={disabled}
      {...props}
    >
      {isSubmitting ? <Loader /> : <>{children}</>}
    </button>
  )
}

export const Loader = () => <span className={loaderStyle} />

export default Button
